import { render } from "./FollowUpNotesCreateOverlay.vue?vue&type=template&id=9dffaf64&scoped=true&lang=pug"
import script from "./FollowUpNotesCreateOverlay.vue?vue&type=script&lang=js"
export * from "./FollowUpNotesCreateOverlay.vue?vue&type=script&lang=js"

import "./FollowUpNotesCreateOverlay.vue?vue&type=style&index=0&id=9dffaf64&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9dffaf64"]])

export default __exports__